"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
import useSecondStepForm from "app/form/[formId]/(formTemplate)/second-step/useSecondStepForm";
import { FormModeProvider } from "forms/contexts/useFormModeContext";
import { FormStatusProvider, useFormStatusContext } from "forms/contexts/useFormStatusContext";
import useRenderFields from "forms/hooks/useRenderFields";
import type { FormMode } from "types/formMode";
import type { IJsonSchema } from "types/jsonSchema";
import type { IUiSchema } from "types/uiSchema";
import { Form } from "uiShadcn/form";
import SubmitButton from "./SubmitButton";
interface PropsForm {
  jsonSchema: IJsonSchema;
  uiSchema: IUiSchema;
  mode: FormMode;
}
function FormContent(t0) {
  const $ = _c(22);
  const {
    uiSchema,
    jsonSchema
  } = t0;
  const formRef = useRef(null);
  const {
    isLoading
  } = useFormStatusContext();
  let t1;
  if ($[0] !== jsonSchema || $[1] !== uiSchema) {
    t1 = {
      jsonSchema,
      uiSchema
    };
    $[0] = jsonSchema;
    $[1] = uiSchema;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    form,
    onSubmitHandler,
    isSubmitting,
    uiSteps
  } = useSecondStepForm(t1);
  const {
    renderFields
  } = useRenderFields();
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useEffect(_temp, t2);
  if (!uiSteps.secondStep || Object.keys(uiSteps.secondStep).length === 0) {
    return null;
  }
  let t3;
  if ($[4] !== form || $[5] !== onSubmitHandler) {
    t3 = form.handleSubmit(onSubmitHandler);
    $[4] = form;
    $[5] = onSubmitHandler;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== form.control || $[8] !== jsonSchema || $[9] !== renderFields || $[10] !== uiSteps.secondStep) {
    t4 = renderFields({
      fields: uiSteps.secondStep,
      control: form.control,
      jsonSchema
    });
    $[7] = form.control;
    $[8] = jsonSchema;
    $[9] = renderFields;
    $[10] = uiSteps.secondStep;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== isLoading || $[13] !== isSubmitting) {
    t5 = <SubmitButton isLoading={isLoading} isSubmitting={isSubmitting} />;
    $[12] = isLoading;
    $[13] = isSubmitting;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t3 || $[16] !== t4 || $[17] !== t5) {
    t6 = <form ref={formRef} onSubmit={t3} className="flex flex-col items-center justify-center gap-n10" autoComplete="on" noValidate={true}>{t4}{t5}</form>;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== form || $[20] !== t6) {
    t7 = <div><Form {...form}>{t6}</Form></div>;
    $[19] = form;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
}
function _temp() {
  window.scrollTo(0, 0);
}
export default function SecondStepForm(props) {
  const $ = _c(5);
  let t0;
  if ($[0] !== props) {
    t0 = <FormStatusProvider><FormContent {...props} /></FormStatusProvider>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.mode || $[3] !== t0) {
    t1 = <FormModeProvider mode={props.mode}>{t0}</FormModeProvider>;
    $[2] = props.mode;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}